import axios from 'axios';
import HasherDao from "./HasherDao";
import Hasher from "../components/Hasher";
import _ from "lodash-es";
import BaseDao from "./BaseDao";
const { DateTime } = require("luxon");

var store = {};

var _copyTrail = (response, fetchEager) => {
  let trail = {};
  trail.id = response.id;
  trail.trailOrdinal = response.trailOrdinal;
  trail.hareIds = response.hares;
  trail.hasherIds = _.difference(response.hashers, response.hares);
  //trail.trailDate = response.date.monthOfYear + '/' + response.date.dayOfMonth + '/' + response.date.year;
  trail.trailDate = response.date;
  trail.time = response.time;
  trail.trailName = "Trail #" + response.id;
  trail.trailLocation = response.location;
  trail.latitude = response.latitude;
  trail.longitude = response.longitude;
  trail.nextTrailId = response.nextTrailId;
  trail.previousTrailId = response.previousTrailId;
  if (fetchEager) {
    HasherDao.fetchByIds(trail.hasherIds.concat(trail.hareIds));
  }

  return trail;
};

export default _.extend(_.clone(BaseDao), {
  _copyEntity: _copyTrail,
  _saveUrl : '/api/trail/saveOrUpdate',
  _deleteByIdURL : '/api/trail/byId/',
  _getByIdURL : '/api/trail/byId/',
  _getByIdsURL: '/api/trail/byIds',
  _getAllURL: '/api/trail/all',
  _getNextTrailIdURL: '/api/trail/next',
  _getAllPromise: null,
  _store : store,
  emptyNewTrail() {
    return {
      id: "new",
      hareIds: [],
      hasherIds: [],
      trailOrdinal : null,
      trailDate : null,
      trailName : null,
      trailLocation : null,
      latitude : null,
      longitude : null,
      nextTrailId : null,
      previousTrailId : null,
    }
  },
  delete(id) {
    return axios.delete(this._deleteByIdURL + id).then(response => {
      console.log(response);
      if (response.data === true) {
        alert("Delete successful. The page will now do a hard reload, as a graceful way of doing this hasn't been implemented yet.")
        delete this._store[id];
        location.href = "/#/trailhistory";
        location.reload();
      } else {
        alert("Delete failed. Boooo.")
      }
    });
  },
  getNext(fetchEager) {
    if (fetchEager === undefined) {
      fetchEager = true;
    }
    //TODO cache this? Error handling
    return new Promise((resolve, reject) => {
        axios.get(this._getNextTrailIdURL).then(response => {
          if (response.data === -1) {
            resolve(null);
          } else {
            resolve(this.fetchById(response.data, fetchEager));
          }
        })
      }
    );
  },
  getAll : function(fetchEager) {
    if (!this._getAllPromise) {
      this._getAllPromise = axios.get(this._getAllURL)
        .then(response => {
          response.data.forEach(trail => {
            this._store[trail.id] = Promise.resolve(_copyTrail(trail, fetchEager));
          });
          return Promise.all(_.cloneDeep(_.values(this._store)));
        })
    }
    return this._getAllPromise;
  }
})

